import "./styles/styles.scss";
import "./styles/shared.scss";
import "./styles/header.scss";
import "./styles/banner.scss";
import "./styles/services.scss";
import "./styles/reviews.scss";
import "./styles/about.scss";
import "./styles/contact.scss";
import "./styles/footer.scss";

import "./js/scroll-animations.js";
import "./js/nav-animation.js";
import Parallax from "./js/parallax.js";

window.onload = () => {
  document.body.style = "opacity: 1;";
  const parallax = new Parallax({
    className: "parallax",
  });

  parallax.init();
};
